<template>
    <v-alert type="error" dense :value="errors && errors.length > 0">
        <div v-for="(e, i) in errors" :key="i">{{ e }}</div>
    </v-alert>
</template>

<style lang="scss" scoped>
    .v-alert {
        margin-bottom: 0 !important;
        font-size: 14px;
    }
</style>

<script>
export default {
    props: ["errors"]
}
</script>